package tta.destinigo.talktoastro.feature_call_consultation.data.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Data(
    @SerialName("emergencyNumber") val emergencyNumber: String? // 01143078552
)
